import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TheFooter the-footer" }
const _hoisted_2 = { class: "the-footer__container page-container" }
const _hoisted_3 = { class: "the-footer__top-left-wrapper" }
const _hoisted_4 = { class: "the-footer__top-right-wrapper" }
const _hoisted_5 = { class: "the-footer__bottom" }
const _hoisted_6 = { class: "page-container the-footer__bottom-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSubscribeNewsletter = _resolveComponent("FormSubscribeNewsletter")!
  const _component_TheFooterContacts = _resolveComponent("TheFooterContacts")!
  const _component_TheFooterList = _resolveComponent("TheFooterList")!
  const _component_TheFooterSocialLinks = _resolveComponent("TheFooterSocialLinks")!
  const _component_TheFooterBottomContent = _resolveComponent("TheFooterBottomContent")!
  const _component_TheFooterBottomLinks = _resolveComponent("TheFooterBottomLinks")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormSubscribeNewsletter),
        _createVNode(_component_TheFooterContacts, { class: "the-footer__contacts" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TheFooterList, { list: _ctx.MENU_FOOTER }, null, 8, ["list"]),
        _createVNode(_component_TheFooterSocialLinks, { class: "the-footer__social-links" })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TheFooterBottomContent),
        _createVNode(_component_TheFooterBottomLinks, { class: "the-footer__bottom-links" }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "the-footer__bottom-copyright small-text" }, " AcreTrader, Inc. Copyright 2019, All rights reserved. ", -1))
      ])
    ])
  ]))
}